"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Connection5_1 = __importDefault(require("./SVG/Connection5"));
const Connection4_1 = __importDefault(require("./SVG/Connection4"));
const Connection3_1 = __importDefault(require("./SVG/Connection3"));
const Connection2_1 = __importDefault(require("./SVG/Connection2"));
const Connection1_1 = __importDefault(require("./SVG/Connection1"));
const Connection0_1 = __importDefault(require("./SVG/Connection0"));
const styles_1 = __importDefault(require("./styles"));
const SVGMap = {
    0: ['noConnection', Connection0_1.default],
    1: ['lowConnection', Connection1_1.default],
    2: ['lowConnection', Connection2_1.default],
    3: ['lowConnection', Connection3_1.default],
    4: ['highConnection', Connection4_1.default],
    5: ['highConnection', Connection5_1.default],
};
const NetworkStatus = (_a) => {
    var { networkMessages, networkLevel, scale, reserveFill, hasStatusMsg = true, anotherMsg = '', className } = _a, rest = __rest(_a, ["networkMessages", "networkLevel", "scale", "reserveFill", "hasStatusMsg", "anotherMsg", "className"]);
    const classes = styles_1.default({ scale });
    const [statusKey, SVG] = SVGMap[networkLevel !== null && networkLevel !== void 0 ? networkLevel : 0];
    const statusMsg = networkMessages && networkMessages[statusKey !== null && statusKey !== void 0 ? statusKey : 'noConnection'];
    return (react_1.default.createElement("div", { className: [classes.container, className].join(' ') },
        react_1.default.createElement("span", null, anotherMsg),
        hasStatusMsg && (react_1.default.createElement("span", { className: classes.statusMessage }, statusMsg)),
        react_1.default.createElement(SVG, Object.assign({ reserveFill: reserveFill, scale: scale }, rest))));
};
exports.default = NetworkStatus;
